import { Card } from '@/components/ui/card';

interface OrderSummaryProps {
  domainCount: number;
  accountCount: number;
  domainPrice: number; // cents
  accountPrice: number; // cents
  hideAccounts?: boolean;
  currencySymbol?: string;
}

export function OrderSummary({
  domainCount,
  accountCount,
  domainPrice,
  accountPrice,
  hideAccounts = false,
  currencySymbol = '$',
}: OrderSummaryProps) {
  const s = currencySymbol;
  const domainTotal = domainCount * domainPrice;
  const accountTotal = accountCount * accountPrice;
  const total = domainTotal + accountTotal;
  const isInactive = domainCount === 0 && accountCount === 0;

  return (
    <Card className={`w-96 py-8 px-6 gap-0 transition-opacity ${isInactive ? 'opacity-50' : ''}`}>
      <div className="space-y-2 pb-4">
        <div className="flex items-center justify-between text-sm text-foreground">
          <span>
            {domainCount > 0
              ? `${domainCount} domain${domainCount !== 1 ? 's' : ''} × ${s}${(domainPrice / 100).toFixed(0)}/yr`
              : 'Domains (annual)'
            }
          </span>
          <span className="font-medium tabular-nums">
            {domainCount > 0 ? `${s}${(domainTotal / 100).toFixed(2)}/yr` : `${s}0.00`}
          </span>
        </div>
        {!hideAccounts && (
          <div className="flex items-center justify-between text-sm text-foreground">
            <span>
              {accountCount > 0
                ? `${accountCount} account${accountCount !== 1 ? 's' : ''} × ${s}${(accountPrice / 100).toFixed(0)}/mo`
                : 'Accounts (monthly)'
              }
            </span>
            <span className="font-medium tabular-nums">
              {accountCount > 0 ? `${s}${(accountTotal / 100).toFixed(2)}/mo` : `${s}0.00`}
            </span>
          </div>
        )}
      </div>
      <div className="pt-4 border-t border-line-strong">
        <div className="flex items-center justify-between text-base font-semibold text-foreground">
          <span>Total due today</span>
          <span className="tabular-nums">
            {s}{(total / 100).toFixed(2)}
          </span>
        </div>
      </div>
    </Card>
  );
}
